import React, { useState } from "react";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image'

import "./App.css";

const HomePage = () => (
  <Container className="mt-5">
    {/* <Row> */}
    <Row className="align-items-center">
      <Col md={5}>
        <Image src="/photo.jpg" rounded fluid />
      </Col>
      <Col md={7}>
        <div className="main-content">
          <p className="pb-3">I am an Assistant Professor of Economics and Computer Science in the <a href="https://cssh.northeastern.edu/faculty/shuo-zhang/">Department of Economics</a> and <a href="https://www.khoury.northeastern.edu/people/shuo-zhang/">Khoury College of Computer Sciences</a> at the Northeastern University. My research interest is in labor economics, platform design and algorithmic fairness.</p>
          <p className="pb-3"><span><b>Research Fields</b></span>: Labor Economics, Behavioral Economics, Applied Econometrics</p>
          <p className="mb-1"><span><b>Email</b>:{' '}<a target="_blank" rel="noopener noreferrer" href="mailto:s.zhang@northeastern.edu" className="main-link" style={{ textDecoration: 'none' }}>s.zhang [at] northeastern [dot] edu</a></span></p>
          <p className="mb-1"><Image src="/github-mark.png" width={20} rounded fluid /><span className="ml-2"><a target="_blank" rel="noopener noreferrer" href="https://github.com/shuo-zhang-ucsb" className="main-link" style={{ textDecoration: 'none' }}>github/shuo-zhang-ucsb</a></span></p>
        </div>
      </Col>
    </Row>

  </Container>
);

const ResearchPage = () => (
  <div>
    <div className="mt-5">
      <h5 className="section-title">Publications</h5>
      <div className="mt-4">
        <h6 className="paper-title"><a target="_blank" rel="noopener noreferrer" href="https://doi.org/10.1016/j.jdeveco.2020.102531" className="paper-link" style={{ textDecoration: 'none' }}>Gender-targeted Job Ads in the Recruitment Process: Facts from a Chinese Job Board</a></h6>
        <p className="mt-2 paper-author">With Peter Kuhn and Kailing Shen, <strong>Journal of Development Economics</strong> 147 (2020): 102531</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title"><a target="_blank" rel="noopener noreferrer" href="https://doi.org/10.1016/j.socec.2020.101536" className="paper-link" style={{ textDecoration: 'none' }}>Words Matter Life: The Effect of Language on Suicide Behavior</a></h6>
        <p className="mt-2 paper-author">With Donald Lien, <strong>Journal of Behavioral and Experimental Economics</strong> 86 (2020): 101536</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title"><a target="_blank" rel="noopener noreferrer" href="https://link.springer.com/article/10.1007/s00148-025-01111-5" className="paper-link" style={{ textDecoration: 'none' }}>Fighting Abuse with Prescription Tracking: Mandatory Drug Monitoring and Intimate Partner Violence</a></h6>
        <p className="mt-2 paper-author">with Dhaval Dave, Bilge Erten, David Hummel and Pinar Keskin, <strong>Journal of Population Economics</strong> 38.3 (2025): 1-27</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title"><a target="_blank" rel="noopener noreferrer" href="https://www.sciencedirect.com/science/article/abs/pii/S0167629625001080?via%3Dihub" className="paper-link" style={{ textDecoration: 'none' }}>From Addiction to Aggression: The Spillover Effects of Opioid Policies on Intimate Partner Violence</a></h6>
        <p className="mt-2 paper-author">with Dhaval Dave, Bilge Erten, and Pinar Keskin, <strong>Journal of Health Economics</strong> 104 (2025) 103073</p>
      </div>
    </div>
    <div className="mt-5">
      <h5 className="section-title">Working Papers</h5>
      <div className="mt-4">
        <h6 className="paper-title">How Biased are Job Recommender Systems? Auditing the Algorithms</h6>
        <p className="mt-2 paper-author">With Peter Kuhn</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title">Should I Show or Should I Hide - When Do Jobseekers Reveal Their Wages?</h6>
        <p className="mt-2 paper-author">With Peter Kuhn, Taoxiong Liu and Kebin Dai</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title">Prime Years, Hidden Bias: Middle Ageism in the Labor Market</h6>
        <p className="mt-2 paper-author">With Lizi Yu, Simin Yuan, Taoxiong Liu and Kebin Dai</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title">Air Pollution and Job Search: Workers’ Willingness to Pay for Clean Air</h6>
        <p className="mt-2 paper-author">with Taoxiong Liu, Lizi Yu and Peng Zhang</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title"><a target="_blank" rel="noopener noreferrer" href="./transforming_minds.pdf" className="paper-link" style={{ textDecoration: 'none' }}>Transforming Minds: The Impact of Public Mental Healthcare Provision on Children’s Outcomes in Brazil</a></h6>
        <p className="mt-2 paper-author">with Diogo Britto, Bilge Erten, Pinar Keskin, and Breno Sampaio</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title">The Invisible Host: Race and Identifiability of Hosts on Airbnb</h6>
        <p className="mt-2 paper-author">With Shariq Mohammed and Yanli Liu</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title">Modeling the Dynamics of Seller Retaliation on Amazon</h6>
        <p className="mt-2 paper-author">with Jeffrey Gleason and Christo Wilson</p>
      </div>
    </div>
    <div className="mt-5">
      <h5 className="section-title">Work In Progress</h5>
      <div className="mt-4">
        <h6 className="paper-title" style={{ display: 'inline' }}>From Disclosure to Blank: The Effect of Marital Status on Job Search Success</h6>
        <p className="mt-2 paper-author">with Simin Yuan, Mindy Marks, Taoxiong Liu and Lizi Yu</p>
      </div>
      <div className="mt-4">
        <h6 className="paper-title" style={{ display: 'inline' }}>Policy Shock and On-the-Job Search: Evidence from China</h6>
        <p className="mt-2 paper-author">with Lizi Yu and Taoxiong Liu</p>
      </div>
    </div>
    <div className="mt-5">
      <h5 className="section-title">R Package Development</h5>
      <div className="mt-4">
        <h6 className="paper-title" style={{ display: 'inline' }}><a target="_blank" rel="noopener noreferrer" href="https://cran.r-project.org/web/packages/DIDmultiplegt/index.html" className="paper-link" style={{ textDecoration: 'none' }}>DIDmultiplegt</a>, <a target="_blank" rel="noopener noreferrer" href="https://cran.r-project.org/web/packages/TwoWayFEWeights/index.html" className="paper-link" style={{ textDecoration: 'none' }}>TwoWayFEWeights</a></h6>
        <p className="mt-2 paper-author">with Clément de Chaisemartin</p>
      </div>
    </div>
  </div >
);

const TeachingPage = () => (
  <div>
    <div className="mt-5">
      <p className="mt-1 main-content">DS 2001 Data Science Practicum</p>
      <p className="mt-1 main-content">ECON 2560 Applied Econometrics</p>
      <p className="mt-1 main-content">ECON 5210 Machine Learning in Economics</p>
    </div>
  </div>
);

const CvPage = () => {
  // Simple user agent check for mobile devices, including iPhone.
  const isMobile = typeof navigator !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    return (
      <div className="mt-5 text-center">
        <a
          href="/cv.pdf"
          className="main-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open CV
        </a>
      </div>
    );
  }

  return (
    <div className="mt-5" style={{ height: "80vh" }}>
      <object data="/cv.pdf#view=FitH" type="application/pdf" width="100%" height="100%">
        <p>Your browser does not support embedded PDFs. You can <a href="/cv.pdf">download the CV here</a>.</p>
      </object>
    </div>
  );
};

const SwitchPage = (props) => {
  return (
    <>
      {(props.page === "home") && <HomePage />}
      {(props.page === "research") && <ResearchPage />}
      {(props.page === "teaching") && <TeachingPage />}
      {(props.page === "cv") && <CvPage />}
    </>
  );
};

const App = () => {
  const [page, setPage] = useState("home");
  const [expanded, setExpanded] = useState(true);

  return (
    <Container className="d-flex p-4 mx-auto flex-column">
      <header><h1 className="header"><a href="/" style={{ textDecoration: 'none' }}><span className="title">Shuo Zhang</span></a></h1></header>
      <Navbar bg="white" expand="sm" expanded={expanded} onToggle={setExpanded}>
        <Container>
          {/* <Navbar.Brand /> */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
            <Nav
              className="justify-content-center float-md-end"
              onSelect={(selectedKey) => {
                setPage(selectedKey);
              }}
            >
              <Nav.Item>
                <Nav.Link eventKey="home">HOME</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="research">RESEARCH</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="teaching">TEACHING</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="cv">VITAE</Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="bg-white">
        <SwitchPage page={page} />
      </div>
    </Container>
  );
};

export default App;
